import { QUESTIONNAIRE_EVALUATION_FAILURE, QUESTIONNAIRE_EVALUATION_INITIALIZATION_POST_SUCCESS, QUESTIONNAIRE_EVALUATION_GET_REQUEST, QUESTIONNAIRE_EVALUATION_GET_REQUEST_SUCCESS, QUESTIONNAIRE_EVALUATION_SAVE_REQUEST, QUESTIONNAIRE_EVALUATION_SAVE_REQUEST_SUCCESS, QUESTIONNAIRE_EVALUATION_QUESTION_GET_SUCCESS, QUESTIONNAIRE_EVALUATION_GET_EVALUATION_ID_SUCCESS, QUESTIONNAIRE_EVALUATION_GET_EVALUATION_ID_BY_EXTERNAL_EVAL_ID_SUCCESS, QUESTIONNAIRE_EVALUATION_GET_EVALUATION_OUTCOME_SUCCESS, QUESTIONNAIRE_EVALUATION_OVERRIDE_SCORE_REQUEST, QUESTIONNAIRE_EVALUATION_OVERRIDE_SCORE_SUCCESS, QUESTIONNAIRE_EVALUATION_RESET_QUESTIONNAIRE } from '../actions';
import { questionnaireEvaluationInstanceCreator } from '../services';
import { questionnaireEvaluationGetEvalIdByExternalEvalIdSuccessReducer } from './questionnaireEvaluationGetEvalIdByExternalEvalIdSuccessReducer';
import { questionnaireEvaluationGetEvaluationIdSuccessReducer } from './questionnaireEvaluationGetEvaluationIdSuccessReducer';
import { questionnaireEvaluationGetFailureReducer } from './questionnaireEvaluationGetFailureReducer';
import { questionnaireEvaluationGetRequestReducer } from './questionnaireEvaluationGetRequestReducer';
import { questionnaireEvaluationGetSuccessReducer } from './questionnaireEvaluationGetSuccessReducer';
import { questionnaireEvaluationInitializationPostReducer } from './questionnaireEvaluationInitializationPostReducer';
import { questionnaireEvaluationOutcomeSuccessReducer } from './questionnaireEvaluationOutcomeSuccessReducer';
import { questionnaireEvaluationQuestionGetSuccessReducer } from './questionnaireEvaluationQuestionGetSuccessReducer';
import { questionnaireEvaluationSaveRequestReducer } from './questionnaireEvaluationSaveRequestReducer';
import { questionnaireEvaluationSaveSuccessReducer } from './questionnaireEvaluationSaveSuccessReducer';
import { questionnaireEvaluationOverrideScoreRequestReducer } from './questionnaireEvaluationOverrideScoreRequestReducer';
import { questionnaireEvaluationOverrideScoreSuccessReducer } from './questionnaireEvaluationOverrideScoreSuccessReducer';
import { questionnaireEvaluationResetReducer } from './questionnaireEvaluationResetReducer';
const questionnaireEvaluationIntitialState = {
    evaluationDocId: 0,
    questionList: [],
    isSaveSuccess: false,
    hasEvaluated: false,
    scoreData: {
        comment: '',
        score: ''
    }
};
export const questionnaireEvaluationRootReducer = (state = questionnaireEvaluationInstanceCreator(questionnaireEvaluationIntitialState), action) => {
    switch (action.type) {
        case QUESTIONNAIRE_EVALUATION_INITIALIZATION_POST_SUCCESS: {
            return questionnaireEvaluationInitializationPostReducer(state, action);
        }
        case QUESTIONNAIRE_EVALUATION_GET_REQUEST: {
            return questionnaireEvaluationGetRequestReducer(state, action);
        }
        case QUESTIONNAIRE_EVALUATION_GET_REQUEST_SUCCESS: {
            return questionnaireEvaluationGetSuccessReducer(state, action);
        }
        case QUESTIONNAIRE_EVALUATION_SAVE_REQUEST: {
            return questionnaireEvaluationSaveRequestReducer(state, action);
        }
        case QUESTIONNAIRE_EVALUATION_SAVE_REQUEST_SUCCESS: {
            return questionnaireEvaluationSaveSuccessReducer(state, action);
        }
        case QUESTIONNAIRE_EVALUATION_FAILURE: {
            return questionnaireEvaluationGetFailureReducer(state, action);
        }
        case QUESTIONNAIRE_EVALUATION_QUESTION_GET_SUCCESS: {
            return questionnaireEvaluationQuestionGetSuccessReducer(state, action);
        }
        case QUESTIONNAIRE_EVALUATION_GET_EVALUATION_ID_SUCCESS: {
            return questionnaireEvaluationGetEvaluationIdSuccessReducer(state, action);
        }
        case QUESTIONNAIRE_EVALUATION_GET_EVALUATION_ID_BY_EXTERNAL_EVAL_ID_SUCCESS: {
            return questionnaireEvaluationGetEvalIdByExternalEvalIdSuccessReducer(state, action);
        }
        case QUESTIONNAIRE_EVALUATION_GET_EVALUATION_OUTCOME_SUCCESS: {
            return questionnaireEvaluationOutcomeSuccessReducer(state, action);
        }
        case QUESTIONNAIRE_EVALUATION_OVERRIDE_SCORE_REQUEST: {
            return questionnaireEvaluationOverrideScoreRequestReducer(state, action);
        }
        case QUESTIONNAIRE_EVALUATION_OVERRIDE_SCORE_SUCCESS: {
            return questionnaireEvaluationOverrideScoreSuccessReducer(state, action);
        }
        case QUESTIONNAIRE_EVALUATION_RESET_QUESTIONNAIRE: {
            return questionnaireEvaluationResetReducer(state, action);
        }
        default: {
            return state;
        }
    }
};
//# sourceMappingURL=questionnaireEvaluationRootReducer.js.map